import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SortIconProps {
  direction: false | 'asc' | 'desc'
  className?: string
}

/**
 * Icono de ordenamiento para headers de tabla
 */
export function SortIcon({ direction, className }: SortIconProps) {
  const baseClass = cn('h-4 w-4', className)

  if (!direction) {
    return <ArrowUpDown className={cn(baseClass, 'text-muted-foreground/50')} />
  }

  if (direction === 'asc') {
    return <ArrowUp className={baseClass} />
  }

  return <ArrowDown className={baseClass} />
}
